<template>
  <div class="year-range-picker">
    <el-select v-model="startYear" placeholder="开始学年" @change="handleStartChange" :disabled="disabled" clearable>
      <el-option v-for="year in years" :key="year" :label="year" :value="year" />
    </el-select>

    <span class="range-separator">{{ rangeSeparator }}</span>

    <el-select v-model="endYear" placeholder="结束学年" @change="handleEndChange" :disabled="disabled || !startYear"
      clearable>
      <el-option v-for="year in endYearOptions" :key="year" :label="year" :value="year" />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'YearRangePicker',
  props: {
    value: {
      type: [String, Array],
      default: () => ''
    },
    yearRange: {
      type: Object,
      default: () => ({ start: 2015, end: 2100 })
    },
    rangeSeparator: {
      type: String,
      default: '至'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const years = [];
    for (let y = this.yearRange.start; y <= this.yearRange.end; y++) {
      years.push(y);
    }

    // 解析传入的value属性，支持"2025-2026学年"格式的字符串和数组形式
    let startYear = null;
    let endYear = null;

    if (typeof this.value === 'string' && this.value.includes('-')) {
      const match = this.value.match(/(\d{4})-(\d{4})/);
      if (match) {
        startYear = parseInt(match[1], 10);
        endYear = parseInt(match[2], 10);
      }
    } else if (Array.isArray(this.value)) {
      startYear = this.value[0];
      endYear = this.value[1];
    }

    return {
      years,
      startYear,
      endYear
    };
  },
  computed: {
    endYearOptions() {
      if (!this.startYear) return this.years;
      return this.years.filter(y => y >= this.startYear);
    }
  },
  watch: {
    // 监听外部传入的value变化
    value(newVal) {
      this.updateYearsFromValue(newVal);
    }
  },
  methods: {
    updateYearsFromValue(newValue) {
      if (typeof newValue === 'string' && newValue.includes('-')) {
        const match = newValue.match(/(\d{4})-(\d{4})/);
        if (match) {
          this.startYear = parseInt(match[1], 10);
          this.endYear = parseInt(match[2], 10);
        }
      } else if (Array.isArray(newValue)) {
        this.startYear = newValue[0];
        this.endYear = newValue[1];
      }
    },
    handleStartChange(val) {
      if (val == "") {
        this.endYear = "";
      } else {
        // 默认设置结束年份为开始年份的下一年
        this.endYear = val + 1;
      }
      this.emitChange();
    },
    handleEndChange(val) {
      if (val == "") {
        this.startYear = "";
      } else {
        // 默认设置结束年份为开始年份的下一年
        this.startYear = val - 1;
      }
      this.emitChange();
    },
    emitChange() {
      if (!this.startYear || !this.endYear) {
        this.$emit('input', '');
        this.$emit('change', '');
        return;
      }

      const formattedValue = `${this.startYear}-${this.endYear}学年`;
      this.$emit('input', formattedValue);
      this.$emit('change', formattedValue);
    }
  },
  mounted() {
    // 初始化时更新年份
    this.updateYearsFromValue(this.value);
  }
};
</script>

<style scoped>
.year-range-picker {
  display: flex;
  align-items: center;
}

.range-separator {
  margin: 0 10px;
  color: #666;
}
</style>